module.exports = __webpack_public_path__ + "static/media/kouzoumis_landing_image_3.30519bda.jpg";